import React, { useState } from "react";

const InventoryManagement = ({ onSaveInventory, uomMaster = [] }) => {
  const [inventoryData, setInventoryData] = useState({
    stockingUoM: "",
    conversionFactors: "",
    storageLocation: "",
    batchNumber: "",
    serialNumber: "",
    lotNumber: "",
    expiryDate: "",
    drugType: "Prescription",
    temperatureRequirement: "",
    safetyStock: "",
    reorderPoint: "",
    maxStock: "",
    leadTime: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInventoryData({ ...inventoryData, [name]: value });
  };

  const handleSave = () => {
    if (!inventoryData.stockingUoM) {
      alert("Please select a Stocking Unit of Measure (UoM).");
      return;
    }
    onSaveInventory(inventoryData);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        Healthcare Inventory Management
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-gray-700 font-medium">
            Stocking Unit of Measure (UoM)
          </label>
          <select
            name="stockingUoM"
            value={inventoryData.stockingUoM}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          >
            <option value="">Select UoM</option>
            {uomMaster.map((uom) => (
              <option key={uom.value} value={uom.value}>
                {uom.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700 font-medium">
            Conversion Factors
          </label>
          <input
            type="text"
            name="conversionFactors"
            value={inventoryData.conversionFactors}
            onChange={handleChange}
            placeholder="e.g., 1 Box = 10 Units"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">
            Storage Location
          </label>
          <input
            type="text"
            name="storageLocation"
            value={inventoryData.storageLocation}
            onChange={handleChange}
            placeholder="e.g., Pharmacy Rack A, Room 101"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Drug Type</label>
          <select
            name="drugType"
            value={inventoryData.drugType}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          >
            <option value="Prescription">Prescription</option>
            <option value="Over-the-Counter">Over-the-Counter</option>
            <option value="Controlled Substance">Controlled Substance</option>
          </select>
        </div>
        <div>
          <label className="block text-gray-700 font-medium">
            Temperature Requirements
          </label>
          <input
            type="text"
            name="temperatureRequirement"
            value={inventoryData.temperatureRequirement}
            onChange={handleChange}
            placeholder="e.g., 2°C - 8°C (Cold Chain)"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">
            Safety Stock Level
          </label>
          <input
            type="number"
            name="safetyStock"
            value={inventoryData.safetyStock}
            onChange={handleChange}
            placeholder="Enter safety stock level"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">
            Reorder Point
          </label>
          <input
            type="number"
            name="reorderPoint"
            value={inventoryData.reorderPoint}
            onChange={handleChange}
            placeholder="Enter reorder point"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">
            Maximum Stock
          </label>
          <input
            type="number"
            name="maxStock"
            value={inventoryData.maxStock}
            onChange={handleChange}
            placeholder="Enter maximum stock level"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">
            Lead Time (days)
          </label>
          <input
            type="number"
            name="leadTime"
            value={inventoryData.leadTime}
            onChange={handleChange}
            placeholder="Enter lead time in days"
            className="w-full border border-gray-300 rounded-lg p-2 mt-2"
          />
        </div>
      </div>
      <button
        type="button"
        onClick={handleSave}
        className="mt-4 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
      >
        Save Inventory
      </button>
    </div>
  );
};

export default InventoryManagement;
